import Link from "next/link";
import { Icon } from "@nju/icons";
import { portalRoutes } from "@nju/routes";
import { A, BlockText, Heading, Separator } from "@nju/ui";

interface ISuccessProps {
  userId: string | undefined;
}

export function Success({ userId }: ISuccessProps) {
  return (
    <div
      className="flex justify-center from-tablet:py-8"
      data-cy="roaming-pending-payment"
    >
      <div className="from-tablet:w-[715px]">
        <Heading
          align="center"
          className="mt-8"
          font="ttfirs"
          tone="neutral"
          variant="h2"
          weight="bold"
        >
          płatność w toku
        </Heading>
        <Separator size="s" tone="invisible" />
        <div className="flex justify-center">
          <Icon
            className="w-12 h-12 from-tablet:w-[90px] from-tablet:h-[90px]"
            name="shopping-bag-incircle-succes"
          />
        </div>
        <Separator size="s" tone="invisible" />
        <BlockText
          align="center"
          size={{ "@onlyMobile": "s", "@fromTablet": "xl" }}
        >
          Włączymy Twój pakiet od razu po potwierdzeniu płatności.
          <Separator size="none" tone="invisible" />
        </BlockText>
        <Separator size="s" tone="invisible" />
        <div className="flex justify-center">
          <Link
            href={portalRoutes.mojeKonto.index.get({
              mode: "mobile",
              ...(userId && { userId }),
            })}
            passHref={true}
          >
            <A
              className="only-mobile:text-center"
              display={{
                "@onlyMobile": "block",
              }}
              size={{ "@onlyMobile": "s" }}
            >
              ok
            </A>
          </Link>
        </div>
      </div>
    </div>
  );
}
